/** @jsx jsx */
// Dependencies
import React, { FC, Fragment } from 'react';
import { Styled, jsx, Container, Box, Link, Text, Flex } from 'theme-ui';

// Components
import translate from '../shared/translate';
import { SanityPost } from '../../graphql-types';
import getUrl from '../shared/getUrl';
import TicketButton from './TicketButton';
import { imageAssetFluidSrc } from '../shared/imageAssetPath';

// Props
interface ArticleProps {
  post: SanityPost;
  styles?: {
    container: Object;
    image: Object;
    box: Object;
    title: Object;
    subtitle: Object;
    link: Object;
    point: Object;
    linkWrapper: Object;
  };
}

// Components
const Article: FC<ArticleProps> = ({
  post: { title, excerpt, slug, featureImage, events },
  styles,
}) => (
  <Container sx={styles.container}>
    <Flex
      sx={{
        backgroundImage: `url(${imageAssetFluidSrc(
          featureImage?.image?.asset
        )})`,
        ...styles.image,
      }}
    />
    <Box sx={styles.box}>
      {!!title && <Styled.h1 sx={styles.title}>{translate(title)}</Styled.h1>}
      {!!excerpt && <Text sx={styles.subtitle}>{translate(excerpt)}</Text>}
      <Flex sx={styles.linkWrapper}>
        <Link href={getUrl('Post', slug)} sx={styles.link}>
          {translate('Read More')}
        </Link>
        {events.length > 0 && (
          <Fragment>
            <Text sx={styles.point}>&#8226;</Text>
            {/* <Link href={events[0].ticketUrl} sx={styles.link}>
              {translate('Buy Ticket')}
            </Link> */}
            <TicketButton event={events[0]} />
          </Fragment>
        )}
      </Flex>
    </Box>
  </Container>
);

// Expert
export default Article;

Article.defaultProps = {
  styles: {
    container: {
      p: [3, 4, 4],
      display: 'flex',
      flexDirection: ['column', 'row', 'row'],
      height: '500px',
    },
    box: {
      backgroundColor: 'foreground',
      color: 'black',
      p: [3, 3, 4],
      alignItems: 'flex-start',
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
      minWidth: [0, '250px', '290px'],
      flex: 1,
    },
    image: {
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      flex: 2,
    },
    title: {
      mt: 0,
      mb: [3, 3, 4],
      fontWeight: 'bold',
      fontSize: [3, 3, 4],
      textTransform: 'uppercase',
    },
    subtitle: {
      fontSize: [1, 2, 3],
      mb: [3, 3, 4],
      display: ['none', 'block'],
    },
    link: {
      fontSize: [1, 2, 3],
      textDecoration: 'none',
      color: 'black',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      fontWeight: 'bold',
    },
    point: {
      mx: 2,
      display: 'inline-block',
    },
    linkWrapper: {
      mb: 2,
    },
  },
};
